/**
 * RESPONSIBILITY: the Bulletin page — the one section it shows, with its pencil.
 */
import { SectionName } from '@app/sections';
import { SectionUpdate } from '../cms';
import { Crumbs, BulletinView, useWords } from '../site';

export function BulletinPage() {
  const w = useWords();
  return (
    <main>
      <SectionUpdate name={SectionName.Bulletin}>
        {(c) => (
          <>
            <Crumbs trail={[{ label: w.aboutLabel }, { label: c.heading }]} />
            <BulletinView c={c} />
          </>
        )}
      </SectionUpdate>
    </main>
  );
}
